import { useQuery } from "@rocicorp/zero/react"

import { mutators } from "@productlane/zero/mutators"
import { queries } from "@productlane/zero/queries"

import { toast } from "@/components/toast"
import { mutateOk, useZero } from "@/lib/zero"

export type DocsTabStyle = "BAR" | "DROPDOWN" | "NAVBAR"

export const DOCS_TAB_STYLE_OPTIONS: { value: DocsTabStyle; label: string }[] =
	[
		{ value: "BAR", label: "Bar under the header" },
		{ value: "DROPDOWN", label: "Dropdown in the sidebar" },
		{ value: "NAVBAR", label: "Header link" },
	]

export const isDocsTabStyle = (value: string): value is DocsTabStyle =>
	DOCS_TAB_STYLE_OPTIONS.some((option) => option.value === value)

/** Saves the workspace's tab style. The header link style has no room for custom tabs. */
export function useSaveDocsTabStyle() {
	const zero = useZero()
	const [tabs] = useQuery(queries.helpCenterTabs())
	const hasDocsTabs = tabs.some((tab) => tab.kind === "DOCS")

	return async (value: string) => {
		if (!isDocsTabStyle(value)) return
		if (value === "NAVBAR" && hasDocsTabs) {
			toast.info({
				title: "Delete your custom tabs first",
				description:
					"The header link style puts the API reference in the header and has no custom tabs.",
			})
			return
		}
		try {
			await mutateOk(
				zero.mutate(mutators.helpCenterTabs.setNavStyle({ style: value })),
				"server",
			)
		} catch (error) {
			toast.error({
				title: "Your tab style wasn't saved",
				description:
					error instanceof Error ? error.message : "Try again in a moment.",
			})
		}
	}
}
